import { buildEvaluateMeasureParameters } from "../utils/EvaluateMeasureParam";
import {
    mapUpCareMeasureReportToStats,
    UpCareStat
} from "../utils/UpCareStats";

export interface ValueMeasureServiceConfig {
    fhirBaseUrl: string;
    measureId: string;
    periodStart: string;
    periodEnd: string;
}

class ValueMeasureService {
    private fhirBaseUrl: string;
    private measureId: string;
    private periodStart: string;
    private periodEnd: string;

    constructor(config: ValueMeasureServiceConfig) {
        this.fhirBaseUrl = config.fhirBaseUrl;
        this.measureId = config.measureId;
        this.periodStart = config.periodStart;
        this.periodEnd = config.periodEnd;
    }

    async evaluate(serviceId?: string): Promise<UpCareStat[]> {
        const response = await fetch(
            `${this.fhirBaseUrl}/Measure/${this.measureId}/$evaluate-measure`,
            {
                method: "POST",
                headers: {
                    Accept: "application/fhir+json",
                    "Content-Type": "application/fhir+json"
                },
                body: JSON.stringify(
                    buildEvaluateMeasureParameters(
                        this.periodStart,
                        this.periodEnd,
                        serviceId
                    )
                )
            }
        );

        if (!response.ok) {
            const errorBody = await response.text();
            throw new Error(errorBody);
        }

        const measureReport = await response.json();

        return mapUpCareMeasureReportToStats(measureReport, 10);
    }
}

export default ValueMeasureService;